import { AccessUser } from "./access-user";

export class AccessRecord {
    ID: any;
    Name: any;
    DisplayName: any;
    IsAccessAllowed: boolean;
    IsAccessRestricted: boolean;
    IsAccessRevoked: boolean;
    UserInfoTitle: string;
    AccessUsers: AccessUser[] = [];
}